import { useTheme } from 'styled-components'
import { ColorVariant, Flex } from 'styling/GlobalStyles'
import { MediumText, SmallText } from 'styling/TypographyV2'
import { IOperationalOverview } from 'features/operationalManagement/operationalManagement.types'
import { AlertRow, AlertsList, PanelContainer, PanelTitle } from '../Organogram.styled'

interface DerivedAlert {
  id: string
  count: number
  title: string
  description: string
  accent: string
}

export const AlertsPanel = ({ overview }: { overview: IOperationalOverview | null }) => {
  const theme = useTheme() as any

  const alerts: DerivedAlert[] = []

  if (overview) {
    if (overview.teamWithoutSupervisorCount > 0) {
      alerts.push({
        id: 'missing-supervisor',
        count: overview.teamWithoutSupervisorCount,
        title: 'Missing Supervisor',
        description: 'Teams are operating without an assigned supervisor',
        accent: theme.colorOrange,
      })
    }
    if (overview.totalUnassignedUserCount > 0) {
      alerts.push({
        id: 'unassigned-employees',
        count: overview.totalUnassignedUserCount,
        title: 'Unassigned Employees',
        description: 'Employees have no active team assignment',
        accent: theme.colorRed,
      })
    }
  }

  return (
    <PanelContainer>
      <PanelTitle>Alerts</PanelTitle>
      {alerts.length === 0 ? (
        <SmallText colorVariant={ColorVariant.SECONDARY}>
          No active alerts.
        </SmallText>
      ) : (
        <AlertsList>
          {alerts.map((a) => (
            <AlertRow key={a.id} accentColor={a.accent}>
              <Flex column gap='0.25rem'>
                <MediumText bold hexColor='inherit'>
                  {a.count} {a.title}
                </MediumText>
                <SmallText colorVariant={ColorVariant.BASE}>
                  {a.description}
                </SmallText>
              </Flex>
            </AlertRow>
          ))}
        </AlertsList>
      )}
    </PanelContainer>
  )
}
